import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchPartsMaster.css";
import CloseForm from "./CloseForm";
import axiosInstance from "../../api";
import Select from "react-select";

function SearchPartsMaster({
  setshowsearchform,
  setIds,
  setPartId,
  setpagenumber,
  setReload,
  setSearch,
  reload,
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Parts/GetAllPartsDropdown`)
      .then((res) => {
        setOptions(res.data);
      })
      .catch(console.log);
  }, []);
  return (
    <div className="search-parts-master-form">
      <h3>Search Parts Master By Entering at least One Field</h3>
      <blockquote>
        <label>Id</label>
        <input
          type="number"
          placeholder="Enter Part Master Id (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setPartId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setPartId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>
      {/*
      <blockquote>
        <label>Number</label>
        <input
          type="text"
          placeholder="Enter Part Number"
          onChange={(e) =>
            setSearchData({ ...searchData, PartNumber: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 10);
          }}
          value={searchData.PartNumber}
        />
      </blockquote>*/}
      <blockquote>
        <label>Part Number</label>
        <Select
          isSearchable
          options={options}
          onChange={(values) => {
            if (values) setIds(values.map((x) => x.value));
          }}
          isMulti
          isClearable
          placeholder="Select Part Number"
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          menuPlacement="top"
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
            }),
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
            control: (base, state) => ({
              ...base,
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
              },
              boxShadow: "none",
            }),
            singleValue: (base) => ({
              ...base,
              color: "black",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "black",
              "&:hover": {
                color: "black",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              backgroundColor: "black",
            }),
            noOptionsMessage: (base) => ({
              ...base,
              color: "black",
            }),
          }}
        />
      </blockquote>
      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>
      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setIds([]);
          setPartId(null);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchPartsMaster;
